import { render, staticRenderFns } from "./SplitReceiverModal.vue?vue&type=template&id=2030ab7d&scoped=true"
import script from "./SplitReceiverModal.vue?vue&type=script&lang=js"
export * from "./SplitReceiverModal.vue?vue&type=script&lang=js"
import style0 from "./SplitReceiverModal.vue?vue&type=style&index=0&id=2030ab7d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030ab7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2030ab7d')) {
      api.createRecord('2030ab7d', component.options)
    } else {
      api.reload('2030ab7d', component.options)
    }
    module.hot.accept("./SplitReceiverModal.vue?vue&type=template&id=2030ab7d&scoped=true", function () {
      api.rerender('2030ab7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/SplitReceiverModal.vue"
export default component.exports